import React from 'react';
import StyledModal from 'styled-react-modal';

export const Modal = ({ children, ...props }) => <StyledModal {...props}>{children}</StyledModal>;
